<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>

    <!-- 新增：服务支持电话 -->
    <div class="service-phone">
      咨询服务电话:18798738026、15877943740
    </div>

    <div class="welcome-info">
      生源地：{{ sourceArea }}，考生,欢迎你！
    </div>

    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img class="user-avatar" :src="avatar">
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>首页</el-dropdown-item>
        </router-link>

        <el-dropdown-item divided @click.native="openUpdatePwdDialog">
          <span style="display:block;">修改密码</span>
        </el-dropdown-item>

        <el-dropdown-item>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <!-- 修改密码弹窗 -->
    <el-dialog
      title="修改登录密码"
      :visible.sync="updatePwdDialogVisible"
      width="420px"
      @close="resetPwdForm"
      center
    >
      <el-form
        ref="pwdForm"
        :model="pwdForm"
        label-width="110px"
        size="small"
        :rules="pwdRules"
        style="padding:20px 0;"
      >
        <el-form-item label="当前密码" prop="oldPassword">
          <el-input
            v-model="pwdForm.oldPassword"
            type="password"
            placeholder="请输入当前使用的密码"
            show-password
            clearable
          />
        </el-form-item>

        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="pwdForm.newPassword"
            type="password"
            placeholder="请设置6-20位新密码"
            show-password
            clearable
          />
        </el-form-item>

        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input
            v-model="pwdForm.confirmPassword"
            type="password"
            placeholder="请再次输入新密码"
            show-password
            clearable
          />
        </el-form-item>
      </el-form>

      <div slot="footer" style="text-align:right;">
        <el-button @click="updatePwdDialogVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="submitUpdatePwd" :loading="pwdLoading" size="small">
          确认修改密码
        </el-button>
      </div>
    </el-dialog>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import { updatePassword } from '@/api/login'

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  data() {
    return {
      updatePwdDialogVisible: false,
      pwdLoading: false,
      pwdForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      pwdRules: {
        oldPassword: [
          { required: true, message: '请输入当前密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度 6-20 位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'name']),
    sourceArea() {
      return this.$store.state.user.sourceArea || ''
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload()
      })
    },
    openUpdatePwdDialog() {
      this.updatePwdDialogVisible = true
    },
    resetPwdForm() {
      this.pwdForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
      this.pwdLoading = false
      if (this.$refs.pwdForm) {
        this.$refs.pwdForm.clearValidate()
      }
    },
    async submitUpdatePwd() {
      const { oldPassword, newPassword, confirmPassword } = this.pwdForm

      if (newPassword !== confirmPassword) {
        this.$message.error('两次输入的新密码不一致')
        return
      }

      this.pwdLoading = true
      try {
        const res = await updatePassword({
          username: this.name,
          oldPassword: oldPassword,
          newPassword: newPassword
        })
        if (res && res.code === 200) {
          this.$message.success('密码修改成功，请重新登录')
          this.updatePwdDialogVisible = false
          setTimeout(() => {
            this.logout()
          }, 800)
        }
      } catch (err) {
        console.error(err)
      } finally {
        this.pwdLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0 !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }

  // 服务电话样式
  .service-phone {
    display: inline-block;
    position: absolute;
    margin-left:10%;
    color: #e64340;
    font-size: 14px;
    font-weight: 500;
  }

  // 欢迎信息样式 右移避免遮挡
  .welcome-info {
    display: inline-block;
    position: absolute;
    right: 100px;
    color: #333;
    font-size: 14px;
  }

  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue